import { __awaiter, __generator } from "tslib";
import { getPricingApiConfig } from './config/actions';
import { fetchPricesGetByIds, fetchPricesGetBySkus } from './http';
export var fetchProductPrices = function (productIds) { return __awaiter(void 0, void 0, void 0, function () {
    var isSFCCPricingOn, prices, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                isSFCCPricingOn = getPricingApiConfig().isSFCCPricingOn;
                if (!isSFCCPricingOn) return [3 /*break*/, 2];
                return [4 /*yield*/, fetchPricesGetBySkus(productIds)];
            case 1:
                response = _a.sent();
                prices = (response === null || response === void 0 ? void 0 : response.data) || null;
                return [3 /*break*/, 4];
            case 2: return [4 /*yield*/, fetchPricesGetByIds(productIds, "p" /* Product */)];
            case 3:
                prices = _a.sent();
                _a.label = 4;
            case 4: return [2 /*return*/, prices];
        }
    });
}); };
